import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js")